import React from 'react';
import { Filter, X } from 'lucide-react';

/**
 * The active-filter chips (05 §1.2, allowlist A17).
 *
 * Spells' removable chips, generalized to every list. The other nine pages ship
 * read-only badge summaries; chips are a strict superset of those, so this is the
 * one deliberate cross-page UI change of the workstream and it is named in the
 * allowlist rather than smuggled in.
 *
 * Each chip carries an `onClear`, so a filter can be removed from the chip
 * itself instead of only through "Clear all".
 *
 * `Clear all` is the copy on nine of the ten shipped pages; Spells says "Clear
 * all filters". The generic panel unifies it here — the difference the generated
 * urlParams suite already matches loosely (`/^Clear all/`).
 */
export default function ActiveFilterChips({ chips, onClearAll }) {
  const active = chips.filter((c) => c && c.label);
  if (!active.length) return null;

  return (
    <div className="active-filters">
      <div className="active-filters-label">
        <Filter className="active-filters-icon" />
        <span className="active-filters-text">Active filters:</span>
        {active.map((chip) => (
          <span key={chip.key} className={`badge ${chip.tone || 'badge-blue'}`}>
            {chip.label}
            <button
              type="button"
              onClick={chip.onClear}
              aria-label={`Remove filter ${chip.label}`}
              className="ml-1 align-middle"
            >
              <X className="w-3 h-3" aria-hidden="true" />
            </button>
          </span>
        ))}
      </div>
      <button type="button" onClick={onClearAll} className="clear-filters-link">
        Clear all
      </button>
    </div>
  );
}
